import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import './NotFound.css';

function NotFound() {
  return (
    <div className="notfound-page">
      <Helmet>
        <title>Page Not Found | Mountain Pine Beetle Foundation</title>
        <meta name="description" content="The page you are looking for could not be found. Return to Mountain Pine Beetle Foundation to learn about forest conservation and pine beetle prevention." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="notfound-header py-5">
        <Container>
          <div className="text-center py-5">
            <div className="notfound-code">404</div>
            <h1 className="mb-3">Page Not Found</h1>
            <p className="notfound-text mx-auto mb-4">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <div className="d-flex justify-content-center gap-2">
              <Button variant="light" size="lg" as={Link} to="/">
                Back to Home
              </Button>
              <Button variant="outline-light" size="lg" as={Link} to="/learn-more">
                Learn More
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}

export default NotFound;
